/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect, useCallback } from "react";
import { Col, Row } from "reactstrap";
import {
  message,
  Button,
  Form,
  Space,
  Card,
  TreeSelect,
  Input,
  DatePicker,
} from "antd";
import moment from "moment";
import { getAllIPDuplicate, getAllCompanys } from "../../helpers/helper";
import DataTable from "../../Components/Common/DataTable";
import ModalInfomation from "./../ApplicationManagement/Components/ModalInfomation";
import { getUserInfoById } from "../../helpers/helper";
import { extractManyId } from "../../common/function";
import { useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;
const { TreeNode } = TreeSelect;

const duplicateIP = () => {
  const { t } = useTranslation();
  document.title = t("duplicateIp");

  const [form] = Form.useForm();
  const [treeDataDepartment, setTreeDataDepartment] = useState([]);

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  const [listDuplicateIPFP, setListDuplicateIPFP] = useState([]);

  //handle time
  const [dates, setDates] = useState([]);

  //info user
  const [infomationUser, setInfomationUser] = useState(false);
  const [showModalInfomation, setShowModalInfomation] = useState(false);
  const columns = [
    {
      title: t("userLogin"),
      dataIndex: "username",
      render: (_, record) => {
        if (record?.username) {
          return (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {record.username.map(
                (item, index) =>
                  item !== null && (
                    <a
                      onClick={() => handleShowModalInfomation(item)}
                      style={{
                        padding: "5px",
                        margin: "2.5px 5px 2.5px 0px",
                        backgroundColor: "#f0f5ff",
                        overflow: "hidden",
                        border: "1px solid #adc6ff",
                        textDecoration: "none",
                      }}
                      key={index}
                    >
                      {item && item.fullName}
                    </a>
                  )
              )}
            </div>
          );
        }
      },
      width: "50%",
    },
    {
      title: t("ip"),
      dataIndex: "ip",
    },
    {
      title: t("createdTime"),
      dataIndex: "time",
      render: (_, record) => {
        if (record) {
          return moment(record?.time?.createdTime)
            .utc("+0700")
            .format("HH:mm YYYY-MM-DD");
        }
      },
    },
  ];
  const setupAllCompany = (dataArray) => {
    try {
      const data =
        dataArray.length > 0 &&
        dataArray.map((company) => {
          return {
            title: company?.companyName,
            value: `company_${company._id}`,
            key: `company_${company._id}`,
            children: company?.departments?.map((department) => {
              return {
                title: department?.departmentName,
                value: `department_${department._id}_company_${company._id}`,
                key: `department_${department._id}_company_${company._id}`,
                children: department?.groups?.map((group) => {
                  return {
                    title: group?.groupName,
                    value: `group_${group._id}_department_${department._id}_company_${company._id}`,
                    key: `group_${group._id}_department_${department._id}_company_${company._id}`,
                  };
                }),
              };
            }),
          };
        });
      return dataArray ? data : [];
    } catch (error) {
      return false;
    }
  };

  const getAllData = useCallback(
    async (_params, indexPage) => {
      setLoading(true);
      try {
        const params = _params
          ? _params
          : {
              pageIndex: indexPage,
              pageSize: pageSize,
              search: "",
              collabs: false,
            };
        const dataRes = await getAllIPDuplicate(params);
        if (dataRes.allCompany) {
          setTreeDataDepartment(setupAllCompany(dataRes.allCompany));
        }
        setTotalPage(dataRes?.totalPages * dataRes?.pageSize);
        if (!dataRes) {
          return false;
        }
        const data =
          dataRes?.data &&
          dataRes?.data.length > 0 &&
          dataRes?.data.map((item, key) => {
            if (item !== null) {
              return {
                key: key,
                username: item.duplicatedUser,
                ip: item.ip,
                time: item,
              };
            }
          });
        setLoading(false);
        return dataRes?.data ? data : [];
      } catch (error) {
        message.error(t("requiredPermission"));
        setTotalPage(0);
        setLoading(false);
        return [];
      }
    },
    [pageSize]
  );

  const getCompany = useCallback(async () => {
    const dataRes = await getAllCompanys();
    if (dataRes) {
      setTreeDataDepartment(setupAllCompany(dataRes));
    }
  }, []);

  useEffect(() => {
    async function fetchData() {
      const dataRes = await getAllData(null, indexPage);
      setListDuplicateIPFP(dataRes);
    }

    fetchData();
    getCompany();
  }, []);

  const onPageChange = async (page, page_size) => {
    const { username, ip, company } = form.getFieldsValue();

    const ids = extractManyId(company);
    const params = {
      pageIndex: page,
      pageSize: page_size,
      collabs: false,
      username: username ? username.toLowerCase() : "",
      ip: ip || "",
      createdTimeStart:
        (dates.length === 2 &&
          moment(dates[0]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      createdTimeEnd:
        (dates.length === 2 &&
          moment(dates[1]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      company: ids.company || "",
      department: ids.department || "",
      group: ids.group || "",
    };
    const dataRes = await getAllData(params, indexPage);
    setListDuplicateIPFP(dataRes.length > 0 ? dataRes : false);
    setPageIndex(page);
    setPageSize(page_size);
  };

  const handleSearch = async () => {
    const dataForm = form.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item) && dates.length === 0) {
      return;
    }
    const ids = extractManyId(dataForm.company);
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      collabs: false,
      username: dataForm?.username ? dataForm?.username.toLowerCase() : "",
      ip: dataForm.ip || "",
      createdTimeStart:
        (dates.length === 2 &&
          moment(dates[0]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      createdTimeEnd:
        (dates.length === 2 &&
          moment(dates[1]?._d).utc("+0700").format("YYYY-MM-DD HH:mm")) ||
        "",
      company: ids.company || "",
      department: ids.department || "",
      group: ids.group || "",
    };
    const dataRes = await getAllData(params, 1);

    setListDuplicateIPFP(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const onChangeRangePicker = (value) => {
    if (value?.length === 2) {
      setDates(value);
    } else {
      setDates([]);
    }
  };

  const handleRefresh = async () => {
    form.resetFields();
    setDates([]);
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      collabs: false,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    setPageIndex(1);
    setListDuplicateIPFP(dataRes.length > 0 ? dataRes : listDuplicateIPFP);
  };

  const handleShowModalInfomation = async (data) => {
    let dataInfoUser = {};
    const res = await getUserInfoById(data?._id);
    dataInfoUser.avatar = res?.avatar;
    dataInfoUser.fullName = res?.fullName;
    dataInfoUser.username = res?.username;
    dataInfoUser.status = res?.status;
    dataInfoUser.email = res?.email;
    dataInfoUser.phoneNumber = res?.phoneNumber;
    dataInfoUser.cv = res?.cv;
    dataInfoUser.company = res?.company?.companyName;
    dataInfoUser.department = res?.department?.departmentName;
    dataInfoUser.group = res?.group?.groupName;
    setInfomationUser(dataInfoUser);
    setShowModalInfomation(true);
  };

  const handleClodeModalInfomation = () => {
    setShowModalInfomation(false);
  };

  return (
    <div className="page-content">
      <Card bordered={false}>
        <Row>
          <Col xs={12}>
            <Form form={form} layout="vertical" autoComplete="off">
              <Row>
                <Col sm={3}>
                  <Form.Item name="username" label={t("userLogin") + ":"}>
                    <Input
                      placeholder={t("placeHolderUserLogin")}
                      allowClear={true}
                    />
                  </Form.Item>
                </Col>
                <Col sm={3}>
                  <Form.Item name="ip" label={t("ip") + ":"}>
                    <Input placeholder={t("placeHolderIp")} allowClear={true} />
                  </Form.Item>
                </Col>
                <Col sm={3}>
                  <Form.Item
                    name="company"
                    label={t("companyDepartmentAndGroup")}
                  >
                    <TreeSelect
                      showSearch
                      treeNodeFilterProp="title"
                      style={{ width: "100%" }}
                      placeholder={t(
                        "placeHolderSelectCompanyDepartmentAndGroup"
                      )}
                      allowClear
                    >
                      {treeDataDepartment &&
                        treeDataDepartment?.map((data) => {
                          return (
                            <TreeNode
                              key={data.key}
                              value={data.value}
                              title={data.title}
                            >
                              {data.children.length > 0
                                ? data.children.map((child) => {
                                    return (
                                      <TreeNode
                                        key={child.key}
                                        value={child.value}
                                        title={child?.title}
                                      >
                                        {child.children.length > 0
                                          ? child.children.map(
                                              (childOfChild) => {
                                                return (
                                                  <TreeNode
                                                    key={childOfChild.key}
                                                    value={childOfChild.value}
                                                    title={childOfChild.title}
                                                  />
                                                );
                                              }
                                            )
                                          : null}
                                      </TreeNode>
                                    );
                                  })
                                : null}
                            </TreeNode>
                          );
                        })}
                    </TreeSelect>
                  </Form.Item>
                </Col>
                <Col sm={3} className="range-picker">
                  <Form.Item label={t("loginTimePeriod") + ":"} />
                  <RangePicker
                    showTime={{ format: "HH:mm" }}
                    format="DD-MM-YYYY HH:mm"
                    value={dates}
                    placeholder={[t("startTime"), t("endTime")]}
                    onChange={onChangeRangePicker}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-1">
                  <Space>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => handleSearch()}
                    >
                      {t("search")}
                    </Button>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={() => handleRefresh()}
                    >
                      {t("reload")}
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
      <div className="duplicate-data">
        <DataTable
          listData={listDuplicateIPFP}
          pageSize={pageSize}
          columns={columns}
          width={700}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
        />
        <ModalInfomation
          showModal={showModalInfomation}
          handleClodeModal={handleClodeModalInfomation}
          infomationUser={infomationUser}
        />
      </div>
    </div>
  );
};

export default duplicateIP;
